module.exports = __webpack_public_path__ + "media/images/flags/uy-d6c82c2d0098885123e33c0980f41d28.svg";